export default __webpack_public_path__ + "3d/e937171ed9929eeaf5f98d53d2fae6f1.obj";